import { FC } from "react";
import { createStyles, Link, makeStyles } from "@material-ui/core";

import { ALL_ACCESS_MEMBERSHIP_URL } from "constants/index";

const useStyles = makeStyles(() =>
  createStyles({
    link: {
      "&&": {
        color: "#000000",
        opacity: 0.87,
        fontSize: 11,
      },
    },
  }),
);

const AllAccessDiscountTooltip: FC = () => {
  const classes = useStyles();

  return (
    <>
      Includes{" "}
      <Link
        className={classes.link}
        href={ALL_ACCESS_MEMBERSHIP_URL}
        target="_blank"
        rel="noopener noreferrer"
        underline="always"
      >
        All Access membership
      </Link>{" "}
      discount, if applicable.
    </>
  );
};

export default AllAccessDiscountTooltip;
